/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./app-charts.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./app-charts.component";
import * as i3 from "../common.service";
import * as i4 from "../api.service";
import * as i5 from "@angular/router";
var styles_AppChartsComponent = [i0.styles];
var RenderType_AppChartsComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_AppChartsComponent, data: {} });
export { RenderType_AppChartsComponent as RenderType_AppChartsComponent };
export function View_AppChartsComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 0, "div", [["class", "chartsWrap"], ["id", "radarCharts"]], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, ["\n"]))], null, null); }
export function View_AppChartsComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-component-charts", [], null, null, null, View_AppChartsComponent_0, RenderType_AppChartsComponent)), i1.ɵdid(1, 4308992, null, 0, i2.AppChartsComponent, [i3.CommonService, i4.ApiService, i5.ActivatedRoute, i5.Router, i1.ElementRef], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var AppChartsComponentNgFactory = i1.ɵccf("app-component-charts", i2.AppChartsComponent, View_AppChartsComponent_Host_0, { chartsType: "chartsType", theme: "theme", chartsData: "chartsData", isCamp: "isCamp", max: "max" }, {}, []);
export { AppChartsComponentNgFactory as AppChartsComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/app-charts/app-charts.component.ngfactory.js.pre-build-optimizer.js